<template>
  <div class="approveBox">
    <qx-card title="申请信息">
      <qx-custom-form
        :noSubBtn="true"
        ref="baseForm"
        :formData="baseForm"
      >
        <section slot="applyUser" slot-scope="prop">
          <ChooseWorker :isRadio="true" v-model="prop.form.applyUser" />
        </section>
      </qx-custom-form>
      <SubBtnBox @sub="sub" />
    </qx-card>
  </div>
</template>

<script>
import SubBtnBox from 'components/subBtnBox';
import ChooseWorker from 'components/choose/worker';
import {
  oilCardApply,
} from 'api/service';
export default {
  components: {
    SubBtnBox,
    ChooseWorker,
  },
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '申请人',
            value: 'applyUser',
            default: {},
            slot: true,
          },
          // {
          //   label: '手机号',
          //   value: 'applyUserPhone',
          //   type: 'input',
          // },
          {
            label: '申请张数',
            value: 'applyOilCount',
            type: 'input',
          },
          {
            label: '备注',
            value: 'applyRemark',
            type: 'input',
            width: '430px',
            attr: {
              type: 'textarea',
              limit: 300,
            },
          },
        ],
        rules: {
          applyUser: [ // 申请人
            { required: true, message: '请选择申请人', trigger: 'blur' },
          ],
          applyOilCount: [ // 申请张数
            { required: true, message: '请输入申请张数', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async sub () {
      const formData = await this.$refs.baseForm.sub();
      if (this.customPost) {
        this.$emit('sub', formData);
        return;
      }
      if (formData) {
        formData.applyUserId = formData.applyUser.userId;
        formData.applyUserPhone = formData.applyUser.loginAcct;
        formData.applyUserName = formData.applyUser.linkman;
        delete formData.applyUser;
        let res = await oilCardApply({
          ...formData,
          isNeedBill: 1,
          productId: this.$route.query.productId,
          isShare: this.$route.query.isShare,
        });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '保存成功',
          });
          this.close();
        }
      }
    },
  },
  // created () {
  //   this.tableData.data = [{customerCode: 123}];
  // },
};
</script>

<style scoped lang="scss">
.approveBox{
  padding-bottom: 56px;
}
</style>
